import React from 'react';
// import BaseConfetti from 'react-confetti';
import Lottie from 'react-lottie';
import animationData from '@ubeya/shared-web/assets/confetti-lotti.json';
import useConfetti from '@ubeya/shared/hooks/useConfetti';

const Confetti = () => {
  const { isFire, setFire } = useConfetti();

  if (!isFire) {
    return null;
  }

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '50%',
        zIndex: 9999, // Adjust this value as needed
        pointerEvents: 'none' // Prevent interaction with elements underneath
      }}>
      <Lottie onComplete={() => setFire(false)} options={defaultOptions} />
    </div>
  );

  // return (
  //   <BaseConfetti
  // onConfettiComplete={() => setFire(false)}
  // recycle={false}
  // opacity={0.8}
  // gravity={0.5}
  // confettiSource={{ x: window.innerWidth / 2, y: window.innerHeight / 2, w: 1, h: 1 }}
  // initialVelocityX={15}
  // initialVelocityY={28}
  // tweenDuration={200}
  // />
  // );
};

export default Confetti;
